import React from 'react';
import logComponent from '../../common/logComponent';

export default function Panel({ children }) {
  if (logComponent('Panel')) { console.debug('Panel rendered'); }

    return (
      <React.Fragment>
        { children }
      </React.Fragment>
    );
}